/**
 * Loops the value, so that it is never larger than length and never smaller than 0.
 *
 * @param value The value.
 * @param length The length.
 * @returns Returns the remainder of the division between value and length.
 * @example
 *
 * repeat(100, 360)
 * // => 180
 *
 * repeat(540, 360)
 * // => 180
 *
 * repeat(-100, 360)
 * // => 260
 */
export function repeat(value: number, length: number): number {
  return ((value % length) + length) % length;
}
